<template>
  <div></div>
</template>
<script>
export default {
  name: 'under-construction'
}
</script>
